import { mergeRel as e } from "../../Footer/base/FooterLink.js";
import t from "clsx";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/Header/base/HeaderLink.tsx
function r({ link: t, linkComponent: r = "a", rel: i, children: a, ...o }) {
	let { href: s, target: c, ...l } = t;
	return /* @__PURE__ */ n(r, {
		href: s,
		target: c,
		rel: e(c, i),
		...l,
		...o,
		children: a
	});
}
var i = (e, n) => t({ underline: e }, "nav-underline", n);
function a({ isActive: e = !1, className: t, ...a }) {
	return /* @__PURE__ */ n(r, {
		className: i(e, t),
		...a
	});
}
//#endregion
export { r as HeaderLink, a as HeaderNavLink, i as navLinkClassName };
